import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import PageNotFound from "@/modules/core/pages/PageNotFound";

import petitionRouter from "@/modules/petition/routers";

import dissRouter from "@/modules/diss/routers";

import coreRouter from "@/modules/core/routers";

import {makeGetRequest, isAliveToken, getUserUid, getGuestUserUid} from "../helper";

Vue.use(Router)

const baseRoutes = [
  {
    path: "*",
    name:"PageNotFound",
    component: PageNotFound
  },
];
var allRoutes = []

allRoutes = allRoutes.concat(
  baseRoutes,
  petitionRouter,
  coreRouter,
  dissRouter
);

const router = new Router(
  {
    base: '/dissertation',
    mode: 'history',
    routes: allRoutes,
  }
);


router.beforeEach((to, from, next) => {
  if(to.meta.instances !== undefined && to.meta.instances.length > 0){
    let instances = '?';
    for(let i in to.meta.instances){
      if(!store.getters['urls/checkAlreadyLoaded'](to.meta.instances[i])) {
        if (i > 0) {
          instances += '&'
        }
        instances += 'instances=' + to.meta.instances[i]
      }
    }

    if(instances !== '?'){
      makeGetRequest(process.env.VUE_APP_INSTANCE_ALLOWED_URLS + instances)
        .then(resp => resp.json())
        .then(data => {
          store.commit('urls/appendUrls', data);
          store.commit('leftmenu/activeRouterChange', to.name);
          next()

        });
    }else
      next()
  }else
    next()
});

router.beforeEach((to, from, next) => {
    if(!store.getters['permissions/checkAlreadyLoaded']){
      if((getUserUid()||getGuestUserUid())){
        makeGetRequest(process.env.VUE_APP_INSTANCE_PERMISSIONS)
          .then(resp => resp.json())
          .then(data => {
            store.commit('permissions/appendPermission', data);
            next()
          });
      }else
        next()
    }else
      next()
});


router.beforeResolve((to, from, next) => {
  if(to.meta.requiredAuth){
    // console.log(to)
    if(store.getters['user/is_authenticate']){
        next()
    } else if(to.params.token) {
      next()
    }else{
      next({
        name: 'PageNotFound',
        query: {redirect: to.fullPath}
      });
    }
  }else{
    next()
  }
});



export default router;
